// Central time helpers. UC Vigil always renders timestamps in Mountain time
// (America/Edmonton — MDT in summer, MST in winter) regardless of the visitor's
// local timezone, so support tickets and audit logs read consistently.
const MDT_TZ = "America/Edmonton";

const _fullFmt = new Intl.DateTimeFormat("en-CA", {
  timeZone: MDT_TZ,
  year: "numeric", month: "short", day: "numeric",
  hour: "2-digit", minute: "2-digit", second: "2-digit",
  hour12: true,
});
const _shortFmt = new Intl.DateTimeFormat("en-CA", {
  timeZone: MDT_TZ,
  month: "short", day: "numeric",
  hour: "2-digit", minute: "2-digit",
  hour12: true,
});
const _timeFmt = new Intl.DateTimeFormat("en-CA", {
  timeZone: MDT_TZ,
  hour: "2-digit", minute: "2-digit", second: "2-digit",
  hour12: true,
});

// Detect Mountain-time abbreviation (MDT during DST, MST otherwise) for a given instant.
const _tzAbbrFmt = new Intl.DateTimeFormat("en-US", {
  timeZone: MDT_TZ,
  timeZoneName: "short",
});
export function mdtAbbr(iso) {
  const d = iso ? new Date(iso) : new Date();
  if (isNaN(d.getTime())) return "MDT";
  const parts = _tzAbbrFmt.formatToParts(d);
  const tz = parts.find((p) => p.type === "timeZoneName");
  return tz?.value || "MDT";
}

function _toDate(v) {
  if (!v) return null;
  const d = v instanceof Date ? v : new Date(v);
  return isNaN(d.getTime()) ? null : d;
}

/** Full Mountain-time timestamp like "Jul 27, 2026, 11:54:55 PM MDT". */
export function fmtMDT(v, { withTz = true } = {}) {
  const d = _toDate(v);
  if (!d) return "—";
  const s = _fullFmt.format(d).replace(",", " ·");
  return withTz ? `${s} ${mdtAbbr(d)}` : s;
}

/** Compact "Jul 27 · 11:54 PM MDT" for tight rows. */
export function fmtMDTShort(v, { withTz = true } = {}) {
  const d = _toDate(v);
  if (!d) return "—";
  const s = _shortFmt.format(d).replace(",", " ·");
  return withTz ? `${s} ${mdtAbbr(d)}` : s;
}

/** Time only, e.g. "11:54:55 PM MDT". */
export function fmtMDTTime(v, { withTz = true } = {}) {
  const d = _toDate(v);
  if (!d) return "—";
  const s = _timeFmt.format(d);
  return withTz ? `${s} ${mdtAbbr(d)}` : s;
}
